/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_EmailInputs */

const en__field_email = /** @type {(inputs: _Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address`)
};

/** @type {(inputs: _Field_EmailInputs) => LocalizedString} */
const de__field_email = en__field_email;

/**
* | output |
* | --- |
* | "Email address" |
*
* @param {_Field_EmailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_email = /** @type {((inputs?: _Field_EmailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_EmailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_email(inputs)
	return de__field_email(inputs)
});